export const convertToE164 = (
  phoneNumber: any,
  prevUser: boolean,
  countryCode = "+1"
) => {
  if (!prevUser) return phoneNumber;
  const sanitizedNumber = phoneNumber.replace(/[^0-9]/g, ""); // Remove non-numeric characters
  return `${countryCode}${sanitizedNumber}`;
};
